import { gql } from "@apollo/client";

export const GET_PROFESIONAL_MONITOREOS = gql`
    query GetProfesionalMonitoreos($idProfesional: Int!) {
        profesionalMonitoreos(idProfesional: $idProfesional) {
            idProfesionalMonitoreo
            idProfesional
            fechaMonitoreo
            idUsuario
            observacionVisitas
            observacionCompletitud
            observacionEntrenamiento
            comentariosGenerales
            puntosResultado
            idUsuarioNavigation{
                nombre
                apellido
            }
            idProfMonitoreoEntrenamiento
            idProfMonitoreoEntrenamientoNavigation{
                idProfMonitoreoEntrenamiento
                descripcion
                resta
            }
            idProfMonitoreoCompletitud
            idProfMonitoreoCompletitudNavigation{
                idProfMonitoreoCompletitud
                descripcion
                resta
            }
            idProfMonitoreoResultado
            idProfMonitoreoResultadoNavigation{
                idProfMonitoreoResultado
                descripcion
            }
            idProfMonitoreoVisitas
            idProfMonitoreoVisitasNavigation{
                idProfMonitoreoVisitas
                descripcion
                resta
            }
            idClaseMonitoreo
            idClaseMonitoreoNavigation{
                descripcion
            }              
            profesionalMonitoreoSugerencia{
                idClaseMonitoreoSugerenciaNavigation{
                    descripcion
                }
                idEstadoNavigation{
                    descripcion
                    idEstadoProfesionalMonitoreoSugerencia
                }
            }
            idProfesionalNavigation{
                fechaProximoMonitoreo
                idClaseMonitoreoNavigation{
                    descripcion
                }
                idCalificacionNavigation{
                    descripcion
                }
            }
            idProfMonitoreoReclamo
            idProfMonitoreoReclamoNavigation{
                descripcion
            }
            idProfesionalNavigation{
                fechaProximoMonitoreo
            }
            profesionalMonitoreoReclamos{
                idGestionReclamoNavigation{
                    idGestionReclamo
                    numeroReclamo
                    correspondeProfesional
                    descripcion
                    fechaOcurrencia
                    fechaRegistro
                    idEstadoReclamo
                    idEstadoReclamoNavigation{
                        descripcion
                    }
                    idUsuarioCreadorNavigation{
                        nombre
                        apellido
                    }
                }
            }
        }
    }
`;